<template>
    <div class="custom-main custom-theme">
        <a-spin :spinning="loading">
            <a-row :gutter="{ xs: 8, sm: 16, md: 16}">
                <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
                <a-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" :xxl="15">
                    <a-row>
                        <a-col span="8">
                            <a-form-item label="出库类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{record.typeName}}</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item label="供应商" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{record.supplierName}}</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                            <a-form-item label="单据号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{record.docNo}}</span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col span="8">
                            <a-form-item label="出库日期" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{record.makeTime}}</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="8">
                          <a-form-item label="出库总量" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                            <span>{{null == record.totalQty ? 0 : record.totalQty.toFixed(0)}}</span>
                          </a-form-item>
                        </a-col>
                        <a-col v-if="false" span="16">
                            <a-form-item label="备注" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                                <a-textarea aria-readonly="true" v-decorator="['remark', {initialValue: record.remark }]" placeholder="请输入备注"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row>

                        <a-col v-if="false" span="16">
                            <a-form-item label="总金额" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                                <span>{{null == record.totalAmount ? 0 : record.totalAmount.toFixed(2) }}</span>
                            </a-form-item>
                        </a-col>
                    </a-row>

                </a-col>
                <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" :xxl="8">&nbsp;</a-col>
            </a-row>
            <a-row>
                <a-col span="2">&nbsp;</a-col>
                <a-col span="20">
                    <a-tabs default-active-key="1"  size="small" style="min-height: 260px;">
                        <a-tab-pane key="1" tab="出库药品">
                            <a-table size="small" :columns="drugGrid.columns" rowKey="id" :data-source="drugGrid.datas" :scroll="{ y: 300 }" :pagination="false" style="padding:4px;">

                            </a-table>
                        </a-tab-pane>
                    </a-tabs>
                </a-col>
            </a-row>
            <a-row>
                <a-col span="2">&nbsp;</a-col>
                <a-col span="20">
                    <div class="button-container">
                        <div>
                            <a-button icon="double-left" style="float:right; margin-right: 24px;" @click="goBack">返回</a-button>
                        </div>
                    </div>
                </a-col>
            </a-row>

        </a-spin>
    </div>
</template>

<script>
  export default {
    name: "StockOutDetail",
    data(){
      return{
        loading : false,
        form: this.$form.createForm(this),
        record:{},
        drugGrid:{
          columns: drugColumn,
          datas: []
        },
      }
    },
    mounted() {
      let self = this;

      /**
       * 加载出库单信息
       */
      let id = this.$route.query.id||'';
      if(id!=''){
        self.loadTip='正在加载出库单信息,请稍候...';
        self.loading = true;
        this.$axios.get('/api/clinic/stockout/'+id).then(function (res) {
          self.loading = false;
          if(res.msg.flag == 0 && res.biz !=null){
            self.record = {id: res.biz.id, docNo:res.biz.docNo, type:res.biz.type, typeName:res.biz.typeName, supplierId : res.biz.supplierId, supplierName:res.biz.supplierName, makeTime: res.biz.makeTime, totalAmount:res.biz.totalAmount,
              totalQty:res.biz.totalQty, status : res.biz.status};
            if(res.biz.drugs!=null && res.biz.drugs.length>0){
              let drugs = [];
              let index = 0;
              for(let drug of res.biz.drugs){
                drugs.push({id:new Date().getTime()+'-'+index, recordId:drug.id, drugId:drug.drugId, name : drug.name, qty:drug.qty, price : drug.price, amt : drug.amt, manufacturer:drug.manufacturer,
                  productionDate:drug.productionDate||'', batchNo:drug.batchNo, validDate:drug.validDate, remark:drug.remark});
                index++;

              }
              self.drugGrid.datas = drugs;
            }
          }else{
            self.loading = false;
            self.$message.error({content:'加载出库单信息失败', duration:2})
          }
        })
      }


    },

    methods:{

      goBack:function (){
        this.$router.go(-1);
      }

    }
  }

  const drugColumn = [
    {
      title: '生产批号',
      dataIndex : 'batchNo',
      key: 'batchNo',
      align: 'center',
      width: 100,
    },
    {
      title: '药品名称',
      dataIndex : 'name',
      key: 'name',
      align: 'center',
      width: 100,
    },{
      title: '生产商',
      dataIndex : 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      width: 100,
    },{
      title: '采购单价',
      dataIndex : 'price',
      key: 'price',
      align: 'center',
      width: 100,
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text.toFixed(2);
      },
    },{
      title: '出库数量',
      dataIndex : 'qty',
      key: 'qty',
      align: 'center',
      width: 100,
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text.toFixed(0);
      },
    },{
      title: '出库金额',
      dataIndex : 'amt',
      key: 'amt',
      align: 'center',
      width: 100,
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text.toFixed(2);
      },
    },{
      title: '生产日期',
      dataIndex : 'productionDate',
      key: 'productionDate',
      align: 'center',
      width: 120,
    },{
      title: '失效日期',
      dataIndex : 'validDate',
      key: 'validDate',
      align: 'center',
      width: 120,
    }
  ]

</script>

<style scoped>
    .drugSpan{
        padding-bottom: 16px;
        color: #fe6e6e;
        width: 80%;
    }
</style>
